export default __webpack_public_path__ + "4e823f6e70330b055074cbba60409673.jpg";